import { createSvgIcon } from '@mui/material';

const GiftVoucher = createSvgIcon(
    <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        fill='none'
    >
        <path
            d='M11.5 7.5C11.5 7.5 10.5 4 7.5 4C5.5 4 5 6 7 7.5C8.5 8.5 11 8 11.5 8V7.5Z'
            fill='currentColor'
        />
        <path
            d='M12.5 7.5C12.5 7.5 13.5 4 16.5 4C18.5 4 19 6 17 7.5C15.5 8.5 13 8 12.5 8V7.5Z'
            fill='currentColor'
        />
        <path
            d='M4 9H11V12H4V9Z'
            fill='currentColor'
        />
        <path
            d='M13 9H20V12H13V9Z'
            fill='currentColor'
        />
        <path
            d='M5 13H11V20H5V13Z'
            fill='currentColor'
        />
        <path
            d='M13 13H19V20H13V13Z'
            fill='currentColor'
        />
    </svg>,
    'GiftVoucher'
);

export default GiftVoucher;